import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { DiganosticEntryComponent } from '../diganostic-entry/diganostic-entry.component';
import { LkpStoresModel } from 'src/app/models/LkpStoresModel';
import { MatDialog } from '@angular/material/dialog';
import { DiganosisModel } from 'src/app/models/DiganosisModel';
import { DiganosisService } from 'src/app/services/DiganosisService';
import { CanserService } from 'src/app/services/CanserService';
import { CanserModel } from 'src/app/models/CanserModel';
import swal from 'sweetalert2';
import { Router } from '@angular/router';
import { CompanyModel } from 'src/app/models/CompanyModel';
import { CompanyService } from 'src/app/services/CompanyService';


@Component({
  selector: 'app-diganostic-tab',
  templateUrl: './diganostic-tab.component.html',
  styleUrls: ['./diganostic-tab.component.css']
})
export class DiganosticTabComponent implements OnInit {
patientcode = '' ;
  Patientname = '';

  OriginalDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  digdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  diglocation = '' ;
  cancerid = '' ;
  CancerName = '';
  tissue = '' ;
  histology = '' ;
  grade = '' ;
  er = '' ;
  pdl1 = '' ;
  msi = '' ;
  egfr = '' ;
  alk = '' ;
  her2 = '' ;
  kras = '' ;
  braf = '' ;
  hrd = '' ;
  brca1 = '' ;
  brca2 = '' ;
  gscore = '' ;
  nfeature = '' ;
  pr = '' ;
  her2ihs = '' ;
  her2fish = '' ;
  ki67 = 0 ;
 
  hpv = '' ;
  digsite = '' ;
  digstage = '' ;
  digt = '' ;
  dign = '' ;
  digm = '' ;
  dignotes = '' ;
  userid = '';
  username = '';
  dignosisdiscription = '';
  wk_font = 2;
  wk_fontsize = '2ch';
  DiganosiseList : DiganosisModel[]=[];
  diglocationtext = [];
  disablepharnacy = false;
  maxCharsPerLine = 75;
  cancername = '';
  wk_Heddin_tissue : boolean[]=[];
  wk_Heddin_histology : boolean[] = [];
  wk_Heddin_grade : boolean[] = [];
  wk_Heddin_er : boolean[] = [];
  wk_Heddin_pdl1 : boolean[] = [];
  wk_Heddin_msi : boolean[] = [];
  wk_Heddin_egfr : boolean[] = [];
  wk_Heddin_alk : boolean[] = [];
  wk_Heddin_her2 : boolean[] = [];
  wk_Heddin_kras : boolean[] = [];
  wk_Heddin_braf : boolean[] = [];
  wk_Heddin_hrd : boolean[] = [];
  wk_Heddin_brca1: boolean[] = [];
  wk_Heddin_brca2: boolean[] = [];
  wk_Heddin_gscore : boolean[] = [];
  wk_Heddin_pr : boolean[] = [];
  wk_Heddin_nfeature : boolean[] = []
  wk_Heddin_her2ihs  : boolean[] = [];
  wk_Heddin_her2fish : boolean[] = [];
  wk_Heddin_ki67     : boolean[] = [];
  wk_Heddin_hpv      : boolean[] = [];
  wk_Heddin_digstage : boolean[] = [];
  wk_Heddin_dign : boolean[] = [];
  wk_Heddin_digm : boolean[] = [];
  wk_Heddin_digt : boolean[] = [];

  wk_SubCancer_Name : string[] = [];
  ki67perc : string[]=[];
  chkuser = '';

  editorConfigNoToolbar = {
    editable: false,
    spellcheck: true,
    showToolbar: false,  // 🚫 This hides the toolbar
    height: 'auto',
    frameElement:false,
    minHeight: '0',
    width: '850px',
    placeholder: '',
    translate: 'no',
    defaultParagraphSeparator: '',
    defaultFontName: '',

    toolbarHiddenButtons: []
  };

  constructor(public stores: LkpStoresModel,
              private dialogref: MatDialog,
              public storage: LocalStorageService,
              public diganosis : DiganosisModel,
              public diganosisService : DiganosisService,
              public companyService : CompanyService,
              public CanserService : CanserService,
              private router : Router) { }

  ngOnInit(): void {
    this.patientcode = this.storage.retrieve('stgPatientCode');
    this.Patientname = this.storage.retrieve('stgPatientName');
    this.digdate =   formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');
    this.RetriveDiganosis();
    if(this.storage.retrieve('stgGroup') !='2' && this.storage.retrieve('stgGroup') !='8'){this.disablepharnacy = true}else{this.disablepharnacy = false}


  }

  ZoomIn(){
    this.wk_font  = this.wk_font  + 0.5;
    this.wk_fontsize = this.wk_font + 'ch';
  }
  ZoomOut(){
    this.wk_font  = this.wk_font  - 0.5;
    this.wk_fontsize = this.wk_font + 'ch';
  }
  limitLineLength() {

    let lines = this.dignotes.split("\n"); // Split by manual Enter presses
    let formattedLines: string[] = [];

    for (let line of lines) {
      while (line.length > this.maxCharsPerLine) {
        formattedLines.push(line.substring(0, this.maxCharsPerLine  - 1 )+ "-"); // Add first 30 chars
        line = line.substring(this.maxCharsPerLine - 1) ; // Remove added part
      }
      formattedLines.push(line); // Add remaining part
    }

    this.dignotes = formattedLines.join("\n"); // Preserve manual and auto lin
  }
RetriveDiganosis(){
           this.DiganosiseList = [];
           this.diganosisService.getDiganosisPatient(this.patientcode).subscribe((data: DiganosisModel[]) => {
              for (let i = 0; i < data.length; i++) {
                this.DiganosiseList[i] = data[i];
                var notes =  this.DiganosiseList[i].dignotes;
         
                if(data[i].cancercode != 'C50'){ this.ki67perc[i] = ''}else{this.ki67perc[i] = '%'};
                ////////-------------------- Get Sub Cancer Name ---------------------------------------
                
                     this.CanserService.getCancerSub(data[i].cancercode,data[i].canceridsub,'1').subscribe((data_sub: CanserModel) => {
                      if (data_sub.cancerName ==null){data_sub.cancerName = ''};               
                      this.wk_SubCancer_Name[i] = '-' + data_sub.cancerName;
                                     
                                 });
                ///////----------------------------------------------------------------------------------
                this.DiganosiseList[i].cancerid = 'Cancer Type :' + data[i].cancerid ;
                this.DiganosiseList[i].cancercode = data[i].cancercode;

                this.DiganosiseList[i].digdate =formatDate(data[i].digdate, 'yyyy-MM-dd', 'en');

                //this.DiganosiseList[i].tissue =this.DiganosiseList[i].tissue;
                if (this.DiganosiseList[i].tissue =='' || this.DiganosiseList[i].tissue ==null){this.DiganosiseList[i].tissue ='';this.wk_Heddin_tissue[i] = true;} else{ this.DiganosiseList[i].tissue =  this.DiganosiseList[i].tissue ;this.wk_Heddin_tissue[i] = false; };
                if (this.DiganosiseList[i].histology =='' || this.DiganosiseList[i].histology ==null){this.DiganosiseList[i].histology ='';this.wk_Heddin_histology[i] = true;} else{ this.DiganosiseList[i].histology =  this.DiganosiseList[i].histology ;this.wk_Heddin_histology[i] = false; };
                if (this.DiganosiseList[i].grade =='' || this.DiganosiseList[i].grade ==null){this.DiganosiseList[i].grade = '';this.wk_Heddin_grade[i] = true;}else{this.DiganosiseList[i].grade;this.wk_Heddin_grade[i] = false;};
                if (this.DiganosiseList[i].er =='' || this.DiganosiseList[i].er ==null){this.DiganosiseList[i].er = '';this.wk_Heddin_er[i] = true; }else{this.DiganosiseList[i].er;this.wk_Heddin_er[i] = false; };
                if (this.DiganosiseList[i].pdl1 =='' || this.DiganosiseList[i].pdl1 ==null){this.DiganosiseList[i].pdl1 = '' ;this.wk_Heddin_pdl1[i] = true;}else{this.DiganosiseList[i].pdl1;this.wk_Heddin_pdl1[i] = false;};
                if (this.DiganosiseList[i].msi =='' || this.DiganosiseList[i].msi ==null){this.DiganosiseList[i].msi = '';this.wk_Heddin_msi[i] = true; }else{  this.DiganosiseList[i].msi;this.wk_Heddin_msi[i] = false;};
                if (this.DiganosiseList[i].egfr =='' || this.DiganosiseList[i].egfr ==null){this.DiganosiseList[i].egfr = '';this.wk_Heddin_egfr[i] = true }else{ this.DiganosiseList[i].egfr;this.wk_Heddin_egfr[i] =false};
                if (this.DiganosiseList[i].alk =='' || this.DiganosiseList[i].alk ==null){this.DiganosiseList[i].alk = '';this.wk_Heddin_alk[i] = true; }else{  this.DiganosiseList[i].alk;this.wk_Heddin_alk[i] = false;};
                if (this.DiganosiseList[i].her2 =='' || this.DiganosiseList[i].her2 ==null){this.DiganosiseList[i].her2 = '';this.wk_Heddin_her2[i] = true; }else{this.DiganosiseList[i].her2;this.wk_Heddin_her2[i] =false;};
                if (this.DiganosiseList[i].kras =='' || this.DiganosiseList[i].kras ==null){this.DiganosiseList[i].kras = '';this.wk_Heddin_kras[i] =true; }else{ this.DiganosiseList[i].kras;this.wk_Heddin_kras[i] =false;};
                if (this.DiganosiseList[i].braf =='' || this.DiganosiseList[i].braf ==null){this.DiganosiseList[i].braf = '';this.wk_Heddin_braf[i] = true; }else{  this.DiganosiseList[i].braf;this.wk_Heddin_braf[i] = false;};
                if (this.DiganosiseList[i].hrd =='' || this.DiganosiseList[i].hrd ==null){this.DiganosiseList[i].hrd = ''; this.wk_Heddin_hrd[i] =true }else{this.DiganosiseList[i].hrd;this.wk_Heddin_hrd[i] = false;};
                if (this.DiganosiseList[i].brca1 =='' || this.DiganosiseList[i].brca1 ==null){this.DiganosiseList[i].brca1 ='';this.wk_Heddin_brca1[i] = true; }else{this.DiganosiseList[i].brca1;this.wk_Heddin_brca1[i] = false;};
                if (this.DiganosiseList[i].brca2 =='' || this.DiganosiseList[i].brca2 ==null){this.DiganosiseList[i].brca2 ='';this.wk_Heddin_brca2[i] = true; }else{this.DiganosiseList[i].brca2;this.wk_Heddin_brca2[i] = false;};
                if (this.DiganosiseList[i].gscore =='' || this.DiganosiseList[i].gscore ==null){this.DiganosiseList[i].gscore = '';this.wk_Heddin_gscore[i] = true;}else{ this.DiganosiseList[i].gscore;this.wk_Heddin_gscore[i]=false;};
                if (this.DiganosiseList[i].pr =='' || this.DiganosiseList[i].pr ==null){this.DiganosiseList[i].pr = '';this.wk_Heddin_pr[i] = true; }else{ this.DiganosiseList[i].pr = this.DiganosiseList[i].pr;this.wk_Heddin_pr[i] = false; };
                if (this.DiganosiseList[i].nfeature =='' || this.DiganosiseList[i].nfeature ==null){this.DiganosiseList[i].nfeature = '';this.wk_Heddin_nfeature[i] = true; }else{  this.DiganosiseList[i].nfeature;this.wk_Heddin_nfeature[i] = false; };
                if (this.DiganosiseList[i].her2ihs =='' || this.DiganosiseList[i].her2ihs ==null){this.DiganosiseList[i].her2ihs = '';this.wk_Heddin_her2ihs[i] =true; }else{ this.DiganosiseList[i].her2ihs = this.DiganosiseList[i].her2ihs;this.wk_Heddin_her2ihs[i] =false; };
                if (this.DiganosiseList[i].her2fish =='' || this.DiganosiseList[i].her2fish ==null){this.DiganosiseList[i].her2fish = '';this.wk_Heddin_her2fish[i] = true; }else{ this.DiganosiseList[i].her2fish;this.wk_Heddin_her2fish[i]=false; };
                if (this.DiganosiseList[i].ki67 == 0 || this.DiganosiseList[i].ki67 ==null){this.DiganosiseList[i].ki67text = '';this.wk_Heddin_ki67[i] =true; }else{this.DiganosiseList[i].ki67;this.wk_Heddin_ki67[i]=false;};
                if (this.DiganosiseList[i].hpv == '' || this.DiganosiseList[i].hpv ==null){this.DiganosiseList[i].hpv = '' ;this.wk_Heddin_hpv[i] = true;}else{ this.DiganosiseList[i].hpv = 'HPV Status:' +  this.DiganosiseList[i].hpv;this.wk_Heddin_hpv[i] = false;};
                if (this.DiganosiseList[i].digstage == '' || this.DiganosiseList[i].digstage ==null){this.DiganosiseList[i].digstage = '' ;this.wk_Heddin_digstage[i] = true;}else{this.DiganosiseList[i].digstage;this.wk_Heddin_digstage[i] = false;};
                if (this.DiganosiseList[i].dign == '' || this.DiganosiseList[i].dign ==null){this.DiganosiseList[i].dign = '' ;this.wk_Heddin_dign[i] = true;}else{this.DiganosiseList[i].dign;this.wk_Heddin_dign[i] = false;};
                if (this.DiganosiseList[i].digm == '' || this.DiganosiseList[i].digm ==null){this.DiganosiseList[i].digm = '' ;this.wk_Heddin_digm[i] = true;}else{this.DiganosiseList[i].digm;this.wk_Heddin_digm[i] = false;};
                if (this.DiganosiseList[i].digt == '' || this.DiganosiseList[i].digt ==null){this.DiganosiseList[i].digt = '' ;this.wk_Heddin_digt[i] = true;}else{this.DiganosiseList[i].digt;this.wk_Heddin_digt[i] = false;};

                this.DiganosiseList[i].digmain = notes
                  this.companyService.getcompany(data[i].diglocation).subscribe((data: CompanyModel) => {
                                     this.diglocationtext[i] = data.compName;
                                 });
              }
            })

  }
EditDiganosis(item : DiganosisModel){

  this.chkuser = item.username;
  if( item.username == this.storage.retrieve('stgusername') || this.storage.retrieve('stgGroup') == '8')
    {

    this.storage.store('stgPatientCode',item.patientcode);
    if(item.patientcode == '' || item.patientcode =='0000'){
      return;
    }
    this.storage.store('stgVisitDate',item.digdate)
    this.storage.store('stgcancerID',item.cancercode)
    const dialogRef = this.dialogref.open(DiganosticEntryComponent,
      {
        data: {
          dataKey: this.diganosis,
        },
        width: '90vw',
        height: '45vw',
      });
      dialogRef.afterClosed().subscribe(result => {
        // Refresh the same route
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/DoctorObservationTab'], {
            queryParams: {
              patientid: this.patientcode,
              patientname: this.Patientname
         //     orgenalcancerid : this.storage.retrieve('stgcancerID')

            }
          });
        });
      });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.RetriveDiganosis();
        dialogSubmitSubscription.unsubscribe();
      });
    }
    else{
      this.MesgWarrning();
    }
}
MessegeDelete(item  : DiganosisModel){
  this.chkuser = item.username;
  if( item.username == this.storage.retrieve('stgusername') || this.storage.retrieve('stgGroup') == '8')
    {
 swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(
      () => {
        this.storage.store('stgPatientCode',item.patientcode);
        this.storage.store('stgVisitDate',item.digdate)
        this.DeleteDiganosis();
        swal('Deleted!', 'Your record has been deleted.', 'success');
      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
  else
  {
    this.MesgWarrning();
  }
}
  DeleteDiganosis(){

      this.diganosisService.deleteDiganosis(this.storage.retrieve('stgVisitDate'),this.storage.retrieve('stgPatientCode')).subscribe(
          (data: DiganosisModel) => {
            this.RetriveDiganosis();
          }
        );
        this. RetriveDiganosis();
  }
openDialog(){
  if(this.patientcode !='0000' && this.patientcode != '' ){

  var wk_Date =formatDate(new Date(), 'yyyy-MM-dd', 'en')
  this.storage.store('stgVisitDate',wk_Date )
  this.storage.store('stgcancerID',this.storage.retrieve('stgcancerIDOrginam'))

  const dialogRef = this.dialogref.open(DiganosticEntryComponent,
      {
        data: {
          dataKey: this.stores

        },
        width: '90vw',
        height: '45vw',
      });
      dialogRef.afterClosed().subscribe(result => {
        // Refresh the same route
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/DoctorObservationTab'], {
            queryParams: {
              patientid: this.patientcode,
              patientname: this.Patientname,

            }
          });
        });
      });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.RetriveDiganosis();
        dialogSubmitSubscription.unsubscribe();
      });
    }
  }
  MesgWarrning(){

    swal({
      title: 'Check User',
      text:'Editing or deleting this medical record allowed only for: ' + this.chkuser,
      type: 'warning',
      showCancelButton: false,
      confirmButtonText: 'OK',
      //cancelButtonText: 'No, keep it',
    })
    ;

  }
}
